import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {cleanupHubspotOAuthCredentials} from 'src/openapi/admin/apis/HubspotControllerApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
};

export const useHubspotRevokeToken = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        cleanupHubspotOAuthCredentials({accountId}),
    ), [accountId, apiDispatch]);

    return useCommonEventHook({eventAction});
};
